// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtEnrollmentClientIdentifiersModel {
    static getAttributeTypeMap() {
        return ExtEnrollmentClientIdentifiersModel.attributeTypeMap;
    }
}
ExtEnrollmentClientIdentifiersModel.discriminator = undefined;
ExtEnrollmentClientIdentifiersModel.additionalProperties = false;
ExtEnrollmentClientIdentifiersModel.attributeTypeMap = [
    {
        "name": "sourceId",
        "baseName": "sourceId",
        "type": "string"
    },
    {
        "name": "alternateId",
        "baseName": "alternateId",
        "type": "string"
    },
    {
        "name": "alternateIdType",
        "baseName": "alternateIdType",
        "type": "string"
    },
];
//# sourceMappingURL=extEnrollmentClientIdentifiersModel.js.map